// NOTE: Keep this independent of React so it can be used in the sitemap generator.

const routes = {
  WELCOME: "/",
  WORKS: "/music",
  ABOUT: "/about",
  BIRTH_YEAR: "/birth-year",
  VISUAL: "/visual",
  WIP: "/wip",
  NEWS: "/news-archive",
  CODE: "/code",
};

export default routes;
